import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslate } from 'core/translate';
import { ButtonText, ThemedButton } from 'core/controls';

const NavNextButton = ({ next }) => {
  const translate = useTranslate();

  if (!next) {
    return null;
  }

  const text = translate('byo.page.general.next.step.parameter', {
    name: translate(next.key)
  });

  return (
    <div className="nav-next-container">
      <ThemedButton
        as={Link}
        primary
        analytics="button"
        className="nav-next-container__button"
        theme={{ cadillac: 'button--alternate' }}
        to={next.path}
        data-dtm="body"
        data-dtm2={text}>
        <ButtonText>{text}</ButtonText>
      </ThemedButton>
    </div>
  );
};

export default NavNextButton;
